/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationid202,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationid400,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationid401,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationid500,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationRequest,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationResponse,
  PutApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParams,
} from "../../types/courseRegistrationDocumentApprovalController/PutApiV1CourseregistrationDocumentApprovalCourseregistrationid.ts";
import { savePersonDocumentApprovalRequestViewModelSchema } from "../savePersonDocumentApprovalRequestViewModelSchema.ts";
import { savePersonDocumentApprovalResponseViewModelSchema } from "../savePersonDocumentApprovalResponseViewModelSchema.ts";

export const putApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationDocumentApprovalCourseregistrationid202Schema =
  z.lazy(
    () => savePersonDocumentApprovalResponseViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationDocumentApprovalCourseregistrationid400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationDocumentApprovalCourseregistrationid401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationDocumentApprovalCourseregistrationid500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationid500>;

export const putApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationRequestSchema =
  z.lazy(
    () => savePersonDocumentApprovalRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationRequest>;

export const putApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationDocumentApprovalCourseregistrationid202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationDocumentApprovalCourseregistrationidMutationResponse>;
